<template>
    <div class="link-collapse" :class="{'link-collapse-active':currentValue}">
        <div class="link-collapse-head" @click="lv_click">
            <slot name="head">
                <span v-if="!!title">{{title}}</span>
            </slot>
            <div class="link-collapse-head-icon-wrapper" v-if="!noIcon">
                <link-icon icon="link-icon-down" :color="iconColor"/>
            </div>
        </div>
        <link-collapse-transition>
            <div class="link-collapse-body" v-show="currentValue">
                <slot>
                    BODY
                </slot>
            </div>
        </link-collapse-transition>
    </div>
</template>

<script>
    import {findComponentUpward} from "../../utils/dom";

    export default {
        name: 'link-collapse',
        props: {
            title: {},
            value: {type: Boolean},
            noIcon: {type: Boolean},
            iconColor: {type: String},
            disabledClickHead: {type: Boolean},
        },
        watch: {
            value(val) {
                val !== this.currentValue && (this.currentValue = val)
            },
            currentValue(val) {
                this.$emit('input', val)
            },
        },
        data() {
            return {
                currentValue: this.value,
                lv_group: null,
            };
        },
        methods: {
            lv_click() {
                this.$emit('clickHead')
                if (this.disabledClickHead) return
                if (!!this.lv_group) this.lv_group.lv_click(this.currentValue, this)
                this.currentValue = !this.currentValue;
            },
        },
        mounted() {
            this.lv_group = findComponentUpward(this, 'link-collapse-group');
            if (!!this.lv_group) this.lv_group.lv_add(this)
        },
        beforeDestroy() {
            if (!!this.lv_group) this.lv_group.lv_remove(this)
        },
    };
</script>

<style lang="scss">
    @include themeify{
        .link-collapse {
            box-sizing: border-box;
            vertical-align: middle;
            width: 100%;
            .link-collapse-head {
                position: relative;
                box-sizing: border-box;
                padding: 12px 32px 12px 16px;

                .link-collapse-head-icon-wrapper {
                    position: absolute;
                    right: 16px;
                    top: 0;
                    bottom: 0;
                    display: flex;
                    align-items: center;
                    .link-icon {
                        @include transition-all-cubic-bezier;
                    }
                }
            }
            .link-collapse-body {

            }

            &.link-collapse-active {
                .link-collapse-head-icon-wrapper .link-icon {
                    transform: rotate(180deg);
                }
            }

        }
    }
</style>
